import { Localized, useLocalization } from "@launerlondon/l10n";
import { routes } from "@launerlondon/shop-router";
import { MarketingStatus, RootState } from "@launerlondon/shop-types";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useFetcher } from "react-router";
import { setCustomerId, setMarketingStatus } from "../redux/actions";
import store from "../redux/store";
import { twMerge } from "tailwind-merge";

type Props = { className?: string; onSuccess?: () => void };

export default function NewsletterForm(props: Props) {
	const { l10n } = useLocalization();
	const form = useRef<HTMLFormElement>(null);
	const { country, lang } = useSelector((s: RootState) => s.locale);
	const { state, data, Form } = useFetcher<{ customerId?: string }>();

	useEffect(() => {
		if (data?.customerId) {
			form.current?.reset();
			store.dispatch(setMarketingStatus(MarketingStatus.Allowed));
			store.dispatch(setCustomerId(data.customerId));
			if (props.onSuccess) props.onSuccess();
		}
	}, [form, data]);

	return (
		<Form
			className={twMerge(
				"grid place-items-center text-center text-sm",
				props.className,
			)}
			ref={form}
			action={routes.newsletter}
			method="post"
		>
			<input type="hidden" name="country" value={country} />
			<input type="hidden" name="lang" value={lang} />
			<input type="hidden" name="optIn" value="true" />
			<input
				className="w-full max-w-xs text-center"
				type="email"
				name="email"
				placeholder={l10n.getString("newsletter-email-placeholder")}
				required
			/>
			<button
				className="button w-full max-w-xs tracking-widest"
				disabled={state !== "idle"}
			>
				<Localized id="newsletter-button" />
			</button>
			<Localized
				id="newsletter-footer"
				elems={{
					url: (
						<Link
							className="hover:text-accent"
							to="/terms-conditions-privacy"
						/>
					),
				}}
				children={
					<p className="mx-auto my-5 max-w-[360px] text-gray-400" />
				}
			/>
		</Form>
	);
}
